import magicStyles from './form-builder.magic.css.js';
import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import script from './form-builder.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":_vm.onSubmit,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onSubmit($event)}}},[(_vm.initialised)?_c('form-builder-partial',{attrs:{"components":_vm.components,"preloaded-data":_vm.preloadedData,"form-data":_vm.formDataModel,"next-step-blocked":_vm.nextStepBlocked},on:{"set-field":function($event){return _vm.setField({ stateKey: _vm.stateKey, field: $event })},"value-update":_vm.onValueUpdate,"state-update":_vm.onFieldStateUpdate,"field-touched":_vm.onFieldTouched}}):_vm._e(),_vm._v(" "),(_vm.step.errorMessage && _vm.shouldShowStepError)?_c('magic-ui-text',{staticClass:"message",attrs:{"tag":"p","part":"message","content":_vm.errorMessageText}}):_vm._e(),_vm._v(" "),(_vm.step.nextButton)?_c('magic-ui-button',{attrs:{"disabled":_vm.nextButtonDisabled,"wide":"","variant":"primary","type":"submit","loading":_vm.isSubmitting,"data-v-test-id":_vm.step.nextButton.testId || ("step" + (_vm.step.path) + "-submit")},domProps:{"innerHTML":_vm._s(_vm.buttonText)},on:{"click":function($event){$event.preventDefault();return _vm.onSubmit($event)}}}):_vm._e()],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-352fe844_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-352fe844";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
